import { render, staticRenderFns } from "./CuentasCorrientes.vue?vue&type=template&id=5fbe1a0e&"
import script from "./CuentasCorrientes.vue?vue&type=script&lang=js&"
export * from "./CuentasCorrientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports